import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';

export default function RequireAuth({ children }) {
  const { user, status } = useAuthStore();
  const location = useLocation();

  // Wait for App.jsx's one-time session bootstrap (GET /api/auth/me) to
  // resolve before deciding anything — otherwise a page refresh with a
  // perfectly valid session cookie would flash straight to /login before
  // that check has had a chance to come back. Rendering nothing briefly is
  // preferable here to a redirect that immediately has to be undone.
  if (status === 'loading') return null;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}
